module.exports = __webpack_public_path__ + "img/a1.cdf9f134.png";